exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-selected[data-v-0e884363]{border:1px solid #ff5722;color:#ff5722}.tab-box[data-v-0e884363]{width:85px;height:32px;border-radius:3px;text-align:center;line-height:29px;font-size:14px;border:1px solid #ccc;background-color:#fff}.tab-selected[data-v-0e884363]{color:#ff5722;border:1px solid #ff5722}", ""]);

// exports
